/**
 * Swiper Component Responsive Handler
 * Detects swiper-component elements nested in .related-collections and sets responsive data-options
 */

(function() {
  let lastBreakpoint = null;

  function getBreakpoint(width) {
    if (width < 750) {
      return 'mobile';
    } else if (width < 990) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  function initSwiperResponsive() {
    const swiperComponents = document.querySelectorAll('.comparison-table__slider');
    if (swiperComponents.length === 0) return;

    const screenWidth = window.innerWidth;
    let options = {};

    // Don't load slider if screen width is 990 or larger
    if (screenWidth >= 990) {
      // Destroy any existing sliders on desktop
      swiperComponents.forEach((component) => {
        const oldSlider = component.flkty;
        if (oldSlider) {
          oldSlider.destroy();
          component.flkty = null;
        }
      });
      return;
    }

    // Set options based on screen width breakpoints
    if (screenWidth < 750) {
      // Mobile
      options = {
        "fade": false,
        "autoPlay": false,
        "prevNextButtons": true,
        "slidesToShow": 1,
        "groupCells": 1,
        "adaptiveHeight": false,
        "cellAlign": "center",
        "wrapAround": true
      };
    } else if (screenWidth < 990) {
      // Tablet
      options = {
        "fade": false,
        "autoPlay": false,
        "prevNextButtons": true,
        "slidesToShow": 3,
        "groupCells": 1,
        "adaptiveHeight": false,
        "cellAlign": "left",
        "wrapAround": true
      };
    }

    // Apply options to each slider-component
    swiperComponents.forEach((component) => {
      // Store the old slider if it exists
      const oldSlider = component.flkty;
      
      // Completely destroy the old slider instance if it exists
      if (oldSlider) {
        oldSlider.destroy();
        component.flkty = null;
      }
      
      // Count the number of slides
      const slides = component.querySelectorAll('[data-slide]');
      const slideCount = slides.length;
      const slidesToShow = options.slidesToShow;
      
      // Disable Flickity if there are not enough slides
      if (slideCount <= slidesToShow) {
        component.classList.add('flickity-disabled');
        return;
      } else {
        component.classList.remove('flickity-disabled');
      }
      
      // Update data-options attribute
      component.setAttribute('data-options', JSON.stringify(options));
      
      // Trigger re-initialization using theme's Flickity class
      if (window.theme && window.theme.Flickity) {
        component.flkty = new window.theme.Flickity(component, options);
      } else if (window.Flickity) {
        component.flkty = new window.Flickity(component, options);
      } else {
        console.error('Flickity library is not loaded.');
      }
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwiperResponsive);
  } else {
    initSwiperResponsive();
  }
  
  // Set initial breakpoint
  lastBreakpoint = getBreakpoint(window.innerWidth);

  // Re-initialize on window resize (with debounce)
  let resizeTimer;
  window.addEventListener('resize', function() {
    const currentBreakpoint = getBreakpoint(window.innerWidth);
    
    // Only trigger if breakpoint has changed
    if (currentBreakpoint !== lastBreakpoint) {
      lastBreakpoint = currentBreakpoint;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSwiperResponsive, 250);
    }
  });
})();
